import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { reloadAuthToken } from "../store/auth/AuthSlice";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

const PrivateRoute = () => 
{  
  // Über unseren Store prüfen, ob der Benutzer bereits authentifiziert wurde  
  //const {isAuthenticated, token} = useSelector(state => state.auth);
  
  const location = useLocation();
  const dispatch = useDispatch();

  // hier im useEffect, damit nur dann ein reload-Authentication token
  // abgefragt wird, wenn es benötigt wird und nicht bei jedem Rendern.
  useEffect( () => 
    {
      dispatch(reloadAuthToken({}));
    }, [dispatch]
  );

  let isAuthenticated = useSelector(state => state.auth.isAuthenticated);      

  if (!isAuthenticated) 
  {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }}  />;
  }  

  return <Outlet />;
}


const RestrictedRoute = () =>
{
  // Über unseren Store prüfen, ob der Benutzer bereits authentifiziert wurde  
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);  
  const location = useLocation();

  if (!isAuthenticated) 
  {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }} />;    
  } 

  return <Outlet />;
}

export { PrivateRoute, RestrictedRoute };